import styled from "styled-components";
import { Container, FlexWrapper, Text1, Text4, Text5 } from "../../../../Components/Common";
import BackgroundImage from "../../../../Assets/BG.svg";
import BackgroundSecondImage from "../../../../Assets/bg/homepage-image2.png";
import BottomBgImage from "../../../../Assets/bg/bottom_every.png";
export const ScribbleImageLogo = styled.img`
  width: 200px;
  height: 270px;
  @media screen and (max-width: 768px) {
    width: 150px;
    height: 150px;
  }
`;

export const CardTwoWrapper = styled.div`
  background: rgba(229, 229, 229, 0.12);
  backdrop-filter: blur(70px);
  border-radius: 10px;
  width: 300px;
  height: 100%;
  padding : ${props=>props.padding || "25px"};
  margin : 0 auto ;  
`;

export const CardTwoHeading = styled(Text5)`
  background: linear-gradient(
    90deg,
    #06d9ca 17.68%,
    #19b6f0 39.18%,
    #6e6cff 50%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const BackgroundImageContainer = styled.div`
  background: url(${BackgroundImage}) no-repeat;
  background-size: cover;
  ${props=>props.backgroundUrl && `background: url(${props.backgroundUrl}) no-repeat;`}
  height : fit-content ; 
`;

export const NumberText = styled(Text1)`
  font-size: 6rem;
  font-family : Inter ; 
  @media screen and (max-width: 768px) {
    font-size: 4rem;
  }
`;

export const ReverseFlexContainer = styled(FlexWrapper)`
  @media screen and (max-width : 768px){
    flex-direction: column-reverse;
    .hide_at_mobile{
      display : none ; 
    }
  }
`

export const EscribelohighBackgroundConatiner = styled.div`
  background: url(${BackgroundSecondImage});
  background-size: cover;
  height : fit-content ; 
`;

export const EscribeloWritesContainer = styled(Container)`
     width : 70%;
     @media screen and (max-width : 1420px){
      width : 85%;
     }

`;

export const BottomBgBackgroundConatiner = styled.div`
  background: url(${BottomBgImage});
  background-size: cover;
  height: fit-content;
  background-position: center;
  background-size: 100% 100%;
`;